export default __webpack_public_path__ + "static/media/cuate.e59a5272.png";